import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import MediatorManager from "../../../core/application/MediatorManager";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import MapsConfig from "../model/MapsConfig";

export default class MapFactory {
    /**
     * @console
     * @param {MediatorManager} mediatorManager 
     * @param {MapsConfig} mapsConfig 
     * @param {LanguagePack} languagePack 
     */
    constructor(mediatorManager, mapsConfig, languagePack) {
        this._mediatorManager = mediatorManager;
        this._mapsConfig = mapsConfig;
        this._languagePack = languagePack;
    }

    createMap(container, mapId) {
        const mapDefinition = this._mapsConfig.getMapById(mapId);
        const movieClipLinkage = mapDefinition.movieClipName;
        const mapSkinConstructor = lib.MainAssets[movieClipLinkage];
        if (!mapSkinConstructor) {
            console.error(`[MapFactory] Cannot create map, movie clip '${movieClipLinkage}' doesn't exists in MainAssets.`);
            return;
        }

        const mapSkin = new mapSkinConstructor();
        container.addChild(mapSkin);

        // Localize locations
        mapSkin.bg.gotoAndStop(0); // Ensure that children array is populated.
        const textFieldsInMap = mapSkin.bg.children.filter(c => c instanceof createjs.Text);
        textFieldsInMap.forEach(textField => textField.text = this._languagePack.getText(`map.labels.${textField.name}`));

        const mapMediator = this._mediatorManager.createMediator(mapSkin, SkinKeyRegistry.MAP_SKIN);
        return mapMediator;
    }
}